class ControllerService {
  constructor(serviceBase) {
    this.serviceBase = serviceBase;
  }

  getSelectOptions(params) {
    return this.serviceBase.getResourceAction('select-options', params);
  }

  getInstanceAction(controllerId, personId) {
    const params = { person_id: personId };
    return this.serviceBase.getInstanceAction(controllerId, 'person-permissions', params);
  }
}

export default ControllerService;



// WEBPACK FOOTER //
// ./src/services/ControllerService.js